import { render, staticRenderFns } from "./FinancialSummary.vue?vue&type=template&id=2d204c9f&scoped=true&"
import script from "./FinancialSummary.vue?vue&type=script&lang=js&"
export * from "./FinancialSummary.vue?vue&type=script&lang=js&"
import style0 from "./expense-card.css?vue&type=style&index=0&id=2d204c9f&prod&scoped=true&lang=css&"
import style1 from "./FinancialSummary.vue?vue&type=style&index=1&id=2d204c9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d204c9f",
  null
  
)

export default component.exports